module.exports = __webpack_public_path__ + "static/media/edg.8d8248f5.svg";